import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { employeereportDetails } from "../../../core/data/json/employeereportDetails";
import { payslipreportDetails } from "../../../core/data/json/payslipreportDetails";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import {
  fetchAllPaySlipReport,
  fetchAllPaySlipReportDetails,
  fetchAllPaySlipReportDetailsMonthly,
} from "../../../core/data/redux/reports/paySlip_report/payslipAction";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToExcel } from "../../../core/common/GlobalFunctions/exportTableData";
import { exportToPDF } from "../../../core/common/GlobalFunctions/exportTableData";
import { exportToCSV } from "../../../core/common/GlobalFunctions/exportTableData";

interface PayslipProps {
  status?: "active" | "inactive";
  department?: string;
  project?: string;
  showOnlyTable?: boolean;
}

const PayslipReport: React.FC<PayslipProps> = ({showOnlyTable})  => {
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedYear, setSelectedYear] = useState("2025");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [monthcount, setMonthcount] = useState<any[] | null>(null);
  const [monthlyCounts, setMonthlyCounts] = useState<number[]>(
    new Array(12).fill(0)
  );
  const dispatch = useDispatch<AppDispatch>();
  const [list, setlist] = useState<any>(null);
  const [details, setdetails] = useState<any>(null);
  const [monthlyDetails, setmonthlyDetails] = useState<any>(null);
  const [tableKey, setTableKey] = useState(0);

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllPaySlipReportDetailsMonthly(selectedYear))
        .then((res: any) => {
          const data = res.payload.data;
          setmonthlyDetails(data);
        })
        .catch((err: any) => {
          console.error("Failed to fetch payslip data:", err);
        });
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  useEffect(() => {
    dispatch(fetchAllPaySlipReportDetails()).then((res) => {
      setdetails(res.payload.data);
    });
    dispatch(fetchAllPaySlipReport()).then((res) => {
      setlist(res.payload.data);
    });
  }, []);
  const data = list ? list : [];

  function filterPayslipData(data: any[]) {
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  return data.map(emp => ({
    PayslipId: emp.payslip_id,
    TransactionId: emp.transaction_id,
    Name: emp.Name || "N/A",
    PaidAmount: emp.PaidAmount || "0",
    PaidMonth: monthNames[(emp.PaidMonth || 1) - 1], 
    PaidYear: emp.PaidYear || "N/A"
  }));
}

const data2 = filterPayslipData(data)


  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, list, data, details, selectedSort]);

  const filteredData = useMemo(() => {
    return filterData(data || [], {}, "CreatedAt", "CreatedAt", selectedSort);
  }, [dispatch, data, list, selectedSort]);

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          {/* <Link
                        to="#"
                        className="avatar avatar-md"
                        data-bs-toggle="modal" data-inert={true}
                        data-bs-target="#view_details"
                    >
                        <ImageWithBasePath
                            src={`assets/img/users/${record.Image}`}
                            className="img-fluid rounded-circle"
                            alt="img"
                        />
                    </Link> */}
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link
                to="#"
                data-bs-toggle="modal"
                data-inert={true}
                data-bs-target="#view_details"
              >
                {record.Name}
              </Link>
            </p>
            <span className="fs-12">{record.Role}</span>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },
    {
      title: "Paid Amount",
      dataIndex: "PaidAmount",
      sorter: (a: any, b: any) => a.PaidAmount.length - b.PaidAmount.length,
    },
    {
      title: "Paid Month",
      dataIndex: "PaidMonth",
      sorter: (a: any, b: any) => a.PaidMonth.length - b.PaidMonth.length,
    },
    {
      title: "Paid Year",
      dataIndex: "PaidYear",
      sorter: (a: any, b: any) => a.PaidYear.length - b.PaidYear.length,
    },
  ];

  useEffect(() => {
    const netPayablePerMonth = new Array(12).fill(0);

    if (monthlyDetails && monthlyDetails.length > 0) {
      monthlyDetails.forEach(({ month, net_payable }: any) => {
        netPayablePerMonth[month - 1] = parseFloat(net_payable);
      });
    }

    setpayslipchart((prev: any) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: netPayablePerMonth,
        },
      ],
    }));
  }, [monthlyDetails]);

  const [payslipchart, setpayslipchart] = useState<any>({
    series: [
      {
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      type: "line",
      height: 200,
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {},
    },
    stroke: {
      curve: "stepline",
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      hover: {
        sizeOffset: 4,
      },
    },
    colors: ["#FF5733"],
  });

  if (showOnlyTable) {
  return (
   <Table
      key={tableKey}
      dataSource={filteredData}
      columns={columns}
      Selection={true}
    />
  );
}

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Payslip Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Payslip Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "PaySlip_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "PaySlip_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                        <div className="">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Total Payroll
                          </span>
                          <h5>
                            {Number(details?.[0]?.net_payable) +
                              Number(details?.[0]?.total_allowances)}
                          </h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-primary border border-primary"
                        >
                          <span className="text-primary">
                            <i className="ti ti-brand-shopee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +20.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                        <div className="">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Deductions
                          </span>
                          <h5>{details?.[0].total_deductions}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-danger border border-danger"
                        >
                          <span className="text-danger">
                            <i className="ti ti-brand-shopee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +17.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                        <div className="">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Net Pay
                          </span>
                          <h5>{details?.[0].net_payable}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-success border border-success"
                        >
                          <span className="text-success">
                            <i className="ti ti-brand-shopee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +10.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                        <div className="">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Allowances
                          </span>
                          <h5>{details?.[0].total_allowances}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-skyblue border border-skyblue"
                        >
                          <span className="text-skyblue">
                            <i className="ti ti-brand-shopee" />
                          </span>
                        </Link>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-danger fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    -10.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-area-line text-danger" />
                      </span>
                      <h5>Payroll</h5>
                    </div>


                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="payslip-chart"
                    options={payslipchart}
                    series={payslipchart.series}
                    type="line"
                    height={215}
                  />
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Payslip List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3"></div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default PayslipReport;
